export enum KsefReceivedDocumentKind {
    Unknown = "Unknown",
    Invoice = "Invoice",
    InvoiceAdjustment = "InvoiceAdjustment",
    AdvanceInvoice = "AdvanceInvoice",
    AdvanceInvoiceAdjustment = "AdvanceInvoiceAdjustment",
    FinalAdvanceInvoice = "FinalAdvanceInvoice",
    FinalAdvanceInvoiceAdjustment = "FinalAdvanceInvoiceAdjustment"
}
